import React from "react";
import { FaBars } from "react-icons/fa"; // Removed FaSearch icon
import { useSelector } from "react-redux";
import icon from "../../Assets/Profile/profileicon/Icon.png";
import "./Header.css";
import IconButton from "../Common/Button/IconButton";
import { roles } from "../../utils/helperFunction";

function Header({ isActive, toggleClass, hideSearch }) {
  const { userData } = useSelector((state) => state.AUTH);
  const getRoleText = (role) => {
    const roleMapping = {
      [roles.rm_super_admin]: "Reliance Super Admin",
      [roles.rm_admin]: "Reliance Admin",
      [roles.admin]: "Admin",
      [roles.approver]: "Approver",
      [roles.user]: "User",
      [roles.superadmin]: "Super Admin",
      [roles.sales_representative]: "Sales Executive",
      [roles.distributor_super_admin]: "Distributor Super Admin",
      [roles.distributor_user]: "Distributor User",
    };

    return roleMapping[role] || "";
  };
  return (
    <div className="header d-lg-none">
      <div className="right_block_header d-flex align-items-center gap-3 flex-wrap flex-grow-1 flex-row-reverse flex-md-row">
        <div className="profile flex-grow-1 align-items-center gap-2">
          {userData && (
            <img
              src={userData?.profile_pic ? userData.profile_pic : icon}
              alt="Profile"
              className="profile-pic"
              onError={(e) => {
                e.target.src = icon;
              }}
            />
          )}
          <div>
            <span className="admin-name">
              {userData &&
                `${userData.first_name} ${
                  userData.last_name ? userData.last_name : ""
                }`}
            </span>
            <span className="superadmin-name">
              {userData && getRoleText(userData.assigned_role)}
            </span>
          </div>
        </div>
        <div className="menu_toggle">
          <IconButton onClick={toggleClass}>
            <FaBars
              className={`toggle_icon ${isActive ? "active" : ""}`}
              color="#000000"
              size={16}
            />
          </IconButton>
        </div>
      </div>
    </div>
  );
}

export default Header;
